import { Injectable } from '@angular/core';
import { AbstractDialogService, canDismissWhenNotSwiped, DialogOptions } from '@examdojo/core/dialog';
import { HomeworkActivityDialogContainerComponent } from './homework-activity-dialog-container.component';

export const HOMEWORK_ACTIVITY_DIALOG_ID = 'homework-activity-dialog';

@Injectable({ providedIn: 'root' })
export class HomeworkActivityDialogService extends AbstractDialogService {
  readonly id = HOMEWORK_ACTIVITY_DIALOG_ID;
  readonly component = HomeworkActivityDialogContainerComponent;

  override options: DialogOptions = {
    cssClass: 'modified-modal font-primary fullscreen',
    backdropDismiss: false,
    handle: false,
    breakpoints: undefined,
    initialBreakpoint: undefined,
    canDismiss: canDismissWhenNotSwiped,
  };
}
